import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import AddIcon from '@material-ui/icons/Add';
import styles from './Shared.module.css';

function Header({
  title,
  newButton = false,
  onNewClicked,
  refreshButton = false,
  onRefreshClicked
}) {
  return (
    <div className={styles.header}>
      <h1>{title}</h1>
      <div>
        {newButton && (
          <IconButton onClick={onNewClicked} data-testid={'add-button'}>
            <AddIcon fontSize={'large'} />
          </IconButton>
        )}
        {refreshButton && (
          <IconButton onClick={onRefreshClicked}>
            <RefreshIcon fontSize={'large'} />
          </IconButton>
        )}
      </div>
    </div>
  );
}

export default Header;
